import { useState } from "react";
import { BellPlus, Bell } from "lucide-react";
import { toast } from "sonner";
import { saveActionReminder } from "../../lib/api";

export function ReminderControl({ card, onSaved, disabled }) {
  const r = card.reminder;
  const [open, setOpen] = useState(false);
  const [text, setText] = useState(r?.text || "");
  const [date, setDate] = useState(r?.due_date || "");
  const [time, setTime] = useState(r?.due_time || "09:00");
  const [saving, setSaving] = useState(false);
  const id = card.id;

  const save = async () => {
    if (!text.trim() || !date || !time) { toast.error("Add the reminder text, date and time."); return; }
    setSaving(true);
    try {
      await saveActionReminder(id, text.trim(), date, time);
      toast.success(`Reminder saved for ${card.full_name}`);
      setOpen(false);
      onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't save the reminder");
    } finally { setSaving(false); }
  };

  return (
    <div className="mt-4" data-testid={`reminder-control-${id}`}>
      {r && (
        <p className="text-sm text-brand-ink flex items-start gap-2" data-testid={`reminder-summary-${id}`}>
          <Bell size={14} className="mt-1 text-[#C8965A]" />
          <span>Reminder for {r.full_name}: “{r.text}” · {r.due_date} {r.due_time}{r.dismissed_at ? " · dismissed" : ""}</span>
        </p>
      )}
      {!disabled && !r?.dismissed_at && !open && (
        <button type="button" onClick={() => setOpen(true)} className="mt-2 text-xs uppercase tracking-[0.2em] font-bold text-brand-ink-muted hover:text-brand-ink inline-flex items-center gap-2" data-testid={`reminder-open-${id}`}>
          <BellPlus size={14} /> {r ? "Edit reminder" : "Add reminder"}
        </button>
      )}
      {open && (
        <div className="mt-3 rounded-2xl border border-brand-border p-4 space-y-3" data-testid={`reminder-form-${id}`}>
          <div className="text-sm font-semibold text-brand-ink">Reminder for {card.full_name}</div>
          <textarea className="input-warm w-full min-h-[70px]" placeholder="e.g. Follow up re physio and create new gym program" value={text} onChange={(e) => setText(e.target.value)} data-testid={`reminder-text-${id}`} />
          <div className="flex flex-wrap gap-3">
            <input type="date" className="input-warm" value={date} onChange={(e) => setDate(e.target.value)} data-testid={`reminder-date-${id}`} />
            <input type="time" className="input-warm" value={time} onChange={(e) => setTime(e.target.value)} data-testid={`reminder-time-${id}`} />
          </div>
          <div className="flex gap-3">
            <button type="button" onClick={save} disabled={saving} className="btn-primary text-sm disabled:opacity-60" data-testid={`reminder-save-${id}`}>{saving ? "Saving…" : "Save reminder"}</button>
            <button type="button" onClick={() => setOpen(false)} className="btn-ghost text-sm" data-testid={`reminder-cancel-${id}`}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ReminderControl;
